var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "m21.748 20.37-5.727-5.734a7.8 7.8 0 0 0 1.643-4.797C17.664 5.516 14.151 2 9.832 2S2 5.516 2 9.84s3.513 7.839 7.832 7.839a7.8 7.8 0 0 0 4.82-1.664l5.723 5.729a.966.966 0 0 0 1.37-.06.98.98 0 0 0 .003-1.315M3.936 9.84a5.9 5.9 0 0 1 5.892-5.898c3.247 0 5.892 2.647 5.892 5.897s-2.645 5.898-5.892 5.898-5.892-2.647-5.892-5.898"
  })));
};
export default SvgIconSearch;